import { render } from "./LoanDetail.vue?vue&type=template&id=347c61c4&scoped=true"
import script from "./LoanDetail.vue?vue&type=script&lang=js"
export * from "./LoanDetail.vue?vue&type=script&lang=js"

import "./LoanDetail.vue?vue&type=style&index=0&id=347c61c4&lang=css"
import "./LoanDetail.vue?vue&type=style&index=1&id=347c61c4&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-347c61c4"]])

export default __exports__